import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PipeActions } from 'Redux/thunks/pipes.thunks';
import { SystemActions } from 'Redux/thunks/systems.thunks';

import SesamLink from 'Common/Links/SesamLink';
import Button from 'Common/Button/Button';
import Page from '../../../components/page';
import { EntitiesTabs } from '../../../containers/EntitiesTabs.container';
import PageHeader, { PageHeaderGroup, PageHeaderTitle } from '../../../components/page-header';

const PipesParent = (props) => (
  <Page>
    <PageHeader>
      <PageHeaderTitle>Pipes</PageHeaderTitle>
      <PageHeaderGroup>
        <Button theme="primary" onClick={() => props.loadAll()}>
          Refresh
        </Button>
        <SesamLink to={`/subscription/${props.subId}/pipes/new`} buttonLink={true}>
          <Button type="button">New pipe</Button>
        </SesamLink>
      </PageHeaderGroup>
    </PageHeader>
    <EntitiesTabs subId={props.subId} entityType="pipes">
      {props.children}
    </EntitiesTabs>
  </Page>
);

PipesParent.propTypes = {
  children: PropTypes.node,
  loadAll: PropTypes.func.isRequired,
  subId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    subId: state.subscription.id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadAll: () => {
      dispatch(PipeActions.loadAll());
      dispatch(SystemActions.loadAll());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PipesParent);
